import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { MISSING_REASONS, formatWhen } from './constants';

class ReviewPanel extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.any.isRequired,
    year: PropTypes.number.isRequired,
    liveState: PropTypes.object,
    schoolList: PropTypes.object,
    profile: PropTypes.object,
    busy: PropTypes.bool,
    onResolve: PropTypes.func.isRequired,
    statusLine: PropTypes.node,
  };

  state = { selected: {} };

  toggle = (firebaseId) => {
    this.setState((s) => ({ selected: { ...s.selected, [firebaseId]: !s.selected[firebaseId] } }));
  };

  toggleAll = (ids) => {
    const allOn = ids.length > 0 && ids.every((id) => this.state.selected[id]);
    const selected = {};
    if (!allOn) ids.forEach((id) => (selected[id] = true));
    this.setState({ selected });
  };

  resolve = (ids, action) => {
    const { year, onResolve } = this.props;
    if (!ids.length) return;
    onResolve(year, ids, action);
    this.setState({ selected: {} });
  };

  campusName(campusNumber) {
    const { schoolList } = this.props;
    const school = schoolList && schoolList[campusNumber];
    return (school && school.name) || campusNumber || '';
  }

  render() {
    const { classes, year, liveState, busy, statusLine } = this.props;
    const { selected } = this.state;
    const pending = (liveState && liveState.pending && liveState.pending[year]) || {};
    const missing = Object.entries(pending.missing || {}).sort(([, a], [, b]) =>
      (a.name || '').localeCompare(b.name || '')
    );
    const unmappedOrgs = Object.entries(pending.unmappedOrgs || {});
    const ids = missing.map(([id]) => id);
    const chosen = ids.filter((id) => selected[id]);
    const allOn = ids.length > 0 && chosen.length === ids.length;
    return (
      <Paper className={classes.section}>
        <Typography variant="subtitle1" color="primary" className={classes.sectionTitle}>
          Needs review ({year}-{year + 1})
        </Typography>
        <Typography className={classes.intro}>
          Students CoPilot rostered from ClassLink that are no longer in the ClassLink pull. Nothing is removed until
          you choose to. Keep converts the student to a CSV-managed record.
        </Typography>
        {statusLine}
        {!missing.length && <Typography className={classes.muted}>No missing students.</Typography>}
        {missing.length > 0 && (
          <div>
            <div className={classes.row}>
              <Button
                variant="outlined"
                color="secondary"
                disabled={busy || !chosen.length}
                onClick={() => this.resolve(chosen, 'remove')}
              >
                Remove selected ({chosen.length})
              </Button>
              <Button
                className={classes.secondaryButton}
                variant="outlined"
                disabled={busy || !chosen.length}
                onClick={() => this.resolve(chosen, 'keep')}
              >
                Keep selected ({chosen.length})
              </Button>
            </div>
            <Table padding="dense">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox checked={allOn} onChange={() => this.toggleAll(ids)} />
                  </TableCell>
                  <TableCell>Student</TableCell>
                  <TableCell>Campus</TableCell>
                  <TableCell>Reason</TableCell>
                  <TableCell>Missing since</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {missing.map(([firebaseId, m]) => (
                  <TableRow key={firebaseId} hover>
                    <TableCell padding="checkbox">
                      <Checkbox checked={!!selected[firebaseId]} onChange={() => this.toggle(firebaseId)} />
                    </TableCell>
                    <TableCell>{m.name || m.sourcedId || firebaseId}</TableCell>
                    <TableCell>{this.campusName(m.campusNumber)}</TableCell>
                    <TableCell>{MISSING_REASONS[m.reason] || m.reason || ''}</TableCell>
                    <TableCell className={classes.cellNarrow}>{formatWhen(m.missingSince)}</TableCell>
                    <TableCell className={classes.cellNarrow}>
                      <Button
                        size="small"
                        color="secondary"
                        disabled={busy}
                        onClick={() => this.resolve([firebaseId], 'remove')}
                      >
                        Remove
                      </Button>
                      <Button size="small" disabled={busy} onClick={() => this.resolve([firebaseId], 'keep')}>
                        Keep
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
        {unmappedOrgs.length > 0 && (
          <div style={{ marginTop: 16 }}>
            <Typography variant="subtitle2" color="primary">
              Unmapped ClassLink schools
            </Typography>
            <Typography className={classes.muted}>
              These schools had students in the last sync but no CoPilot campus. Map them in Campus mapping above.
            </Typography>
            <Table padding="dense">
              <TableHead>
                <TableRow>
                  <TableCell>School</TableCell>
                  <TableCell>Identifier</TableCell>
                  <TableCell>Students</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {unmappedOrgs.map(([id, o]) => (
                  <TableRow key={id}>
                    <TableCell>{o.name || id}</TableCell>
                    <TableCell className={classes.sample}>{o.identifier || ''}</TableCell>
                    <TableCell>{o.studentCount != null ? o.studentCount : ''}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Paper>
    );
  }
}

export default ReviewPanel;
